import Box from "@mui/material/Box";
// types
import { type TransportProviderLogoType } from "../types";

interface TransportProviderLogoProps {
  logo?: TransportProviderLogoType | null;
}

export default function TransportProviderLogo({ logo }: TransportProviderLogoProps) {
  if (!logo?.url) {
    return null;
  }

  return (
    <Box className={`transport-provider-logo`}>
      <img src={logo.url} alt={logo.name || "provider-logo"} className="transport-provider-logo__image" />
    </Box>
  );
}
